import React, { useState } from 'react';
import '../styles/PlayPauseButton.css'
// import { data } from './Board.js';
import { useEffect } from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';
import ReactGA from 'react-ga4';

const math = require('mathjs');

let backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8800';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

// Right now date is imported once only :(
function PlayPauseButton(props) {
    const { data } = require('./Board.js');
    

    // For new play/pause button 
    const [isPlaying, setIsPlaying] = useState(!data.paused);
    useEffect(() => {
        if (isPlaying) {
            data.paused = false;
            console.log('Model is Playing');
        } else {
            data.paused = true;
            console.log('Model is Paused');
        }
    }, [isPlaying]);
    useEffect(() => {
        console.log("There is change in data.pause")
        setIsPlaying(!props.isPaused)
    }, [props.isPaused]);
    const handleClick = (isPlaying) => {
        if (props.modelStatus ==='uploaded') {
            data.paused = false;
            setIsPlaying(!isPlaying);
        } else {
            data.paused = true;
            setShowUploadingModal(true); // Show Model still being uploaded modal
            // alert('Upload Model first!');
        }

        // Update Run Count
        // fetch(`${backendUrl}/api/runcount`, {
        //     method: 'POST',
        //     body: JSON.stringify({
        //       page: window.location.pathname,
        //     }),
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //   })
        //     .then(() => {
        //       console.log('Run Count tracked');
        //     })
        //     .catch(error => {
        //       console.error(error);
        //     });

        // Send 
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Play Button is clicked'
        });
    }


    // For Upload Modal
    const [showUploadingModal, setShowUploadingModal] = useState(false);
    useEffect(() => {
        console.log("There is change in data.model_status")

        if(props.modelStatus ==='uploaded'){
            setShowUploadingModal(false);
        }

    }, [props.modelStatus]);


    function handleClickModal(event) {
        event.stopPropagation(); // prevent click events from propagating to parent elements
    }


    return (

        // <div className='playpause-div'>
        //     <IconButton onClick={handleClick}>
        //         {isPlaying ? <PauseIcon fontSize="large" className="neon" /> : <PlayArrowIcon fontSize="large" className="neon" />}
        //     </IconButton>
        // </div>
        <div>
            <div className="playpause-container">
                <button className='btn-primary playpause-btn' onClick={handleClick} data-theme={data.theme}>
                    {isPlaying ? <FaPause size={15} /> : <FaPlay size={15} className="playpause" />}
                </button>
            </div>

            {showUploadingModal && (
                <div className="modal" onClick={handleClickModal}>
                    <div className="modal-content uploadModal">
                        <div class="loader"></div>
                        Please wait, model is being uploaded...
                        <br/><br/> Click Play button again after this message disappears.
                    </div>
                </div>)}

        </div>


    );
}

export default PlayPauseButton;